module.exports = __webpack_public_path__ + "static/img/xiangqing.f744840.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/xiangqing.png
// module id = /Pq7
// module chunks = 24